import React from 'react';
import PropTypes from 'prop-types';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';

const EmbeddedPageFrame = ({ embedded, containerClassName, nav, children }) => {
  if (embedded) {
    return <div className="vibe-more-feature">{children}</div>;
  }
  return (
    <CommonPageComponent containerClassName={containerClassName}>
      {nav}
      {children}
    </CommonPageComponent>
  );
};

EmbeddedPageFrame.propTypes = {
  embedded: PropTypes.bool,
  containerClassName: PropTypes.string,
  nav: PropTypes.node,
  children: PropTypes.node,
};

EmbeddedPageFrame.defaultProps = {
  embedded: false,
  containerClassName: '',
  nav: null,
  children: null,
};

export default EmbeddedPageFrame;
